var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 65,
    viewBox: "0 0 37 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78967 23.4143C6.45658 23.747 6.45658 24.2867 6.78967 24.6195L11.2302 29.06C11.3966 29.2264 11.6148 29.3096 11.833 29.3096C12.0512 29.3096 12.2694 29.2264 12.4357 29.06C12.7688 28.7273 12.7688 28.1876 12.4357 27.8549L7.99484 23.4143C7.6621 23.0812 7.12207 23.0812 6.78967 23.4143Z",
    fill: "url(#paint0_linear_2_72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30809 18.1883C1.91807 18.2354 1.6109 18.5425 1.56385 18.9326C1.53692 19.1566 0.937229 24.4518 3.9476 27.4622C6.06782 29.5827 9.32196 29.9121 11.1388 29.9121C11.9011 29.9121 12.4107 29.8541 12.4772 29.8459C12.8672 29.7989 13.1744 29.4917 13.2215 29.1017C13.2484 28.8777 13.8481 23.5825 10.8377 20.5721C7.82734 17.5617 2.53208 18.1611 2.30809 18.1883ZM11.5724 28.1969C10.1729 28.2405 7.00639 28.1103 5.15278 26.2567C3.29882 24.4027 3.16927 21.2372 3.21257 19.837C4.61445 19.7948 7.77859 19.9236 9.6322 21.7773C11.4862 23.6312 11.6157 26.7974 11.5724 28.1969Z",
    fill: "url(#paint1_linear_2_72)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3434 29.2811C24.5098 29.4475 24.728 29.5306 24.9462 29.5306C25.1644 29.5306 25.3826 29.4475 25.549 29.2811L30.2104 24.6196C30.5435 24.2869 30.5435 23.7472 30.2104 23.4144C29.8777 23.0813 29.3377 23.0813 29.0053 23.4144L24.3438 28.0759C24.0107 28.4086 24.0107 28.9483 24.3434 29.2811Z",
    fill: "url(#paint2_linear_2_72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.779 29.1014C23.826 29.4914 24.1332 29.7986 24.5232 29.8456C24.5894 29.8535 25.0987 29.9118 25.8617 29.9118C27.6789 29.9118 30.9327 29.5824 33.0529 27.4619C36.0632 24.4515 35.4636 19.1562 35.4366 18.9322C35.3896 18.5422 35.0824 18.235 34.6924 18.188C34.4681 18.1611 29.1728 17.561 26.1628 20.5717C23.1524 23.5821 23.7521 28.8777 23.779 29.1014ZM27.3679 21.7773C29.2219 19.9233 32.387 19.7938 33.7876 19.8371C33.8309 21.2372 33.7013 24.4027 31.8474 26.2567C29.9934 28.1106 26.8286 28.2426 25.4277 28.1969C25.3844 26.7967 25.514 23.6312 27.3679 21.7773Z",
    fill: "url(#paint3_linear_2_72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0537 28.1471C11.5829 28.1471 11.2014 28.5286 11.2014 28.9994C11.2014 29.4702 11.5829 29.8517 12.0537 29.8517H24.9458C25.4166 29.8517 25.7981 29.4702 25.7981 28.9994C25.7981 28.5286 25.4166 28.1471 24.9458 28.1471H12.0537Z",
    fill: "url(#paint4_linear_2_72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.471 3.73478L25.0678 2.33153C24.5114 1.77479 23.6485 1.66536 22.969 2.06492L21.5702 2.89064L21.1645 1.31659C20.9671 0.554621 20.2795 0.0220947 19.4923 0.0220947H17.5077C16.7205 0.0220947 16.0329 0.554621 15.8352 1.31761L15.4298 2.89064L14.03 2.06424C13.3519 1.66536 12.489 1.77514 11.9322 2.33153L10.529 3.73478C9.97225 4.29151 9.86213 5.15405 10.262 5.83352L11.0878 7.23268L9.51371 7.63804C8.7514 7.83543 8.21887 8.52308 8.21887 9.31062V11.2951C8.21887 12.0823 8.75106 12.77 9.51439 12.9677L11.0874 13.3731L10.261 14.7729C9.86179 15.4517 9.97157 16.3143 10.5286 16.8707L11.9319 18.2739C12.4883 18.8306 13.3515 18.9411 14.0306 18.5405L15.4298 17.7148L15.8355 19.2892C16.0329 20.0515 16.7205 20.5837 17.5077 20.5837H19.4923C20.2795 20.5837 20.9671 20.0515 21.1648 19.2882L21.5702 17.7151L22.9697 18.5412C23.6481 18.9408 24.511 18.8306 25.0678 18.2739L26.471 16.8707C27.0281 16.3139 27.1382 15.451 26.738 14.7719L25.9122 13.3728L27.4866 12.967C28.2489 12.7697 28.7811 12.082 28.7811 11.2948V9.31028C28.7811 8.52274 28.2486 7.83509 27.4863 7.6377C27.4863 7.6377 27.486 7.6377 27.4856 7.6377L25.9122 7.23234L26.7383 5.83249C27.1379 5.15405 27.0281 4.29117 26.471 3.73478ZM27.0598 9.28846L27.2725 8.46308L27.0762 9.31028L27.0601 11.317L24.3897 12.005C24.1302 12.0718 23.9175 12.2566 23.8149 12.5041C23.7122 12.7516 23.732 13.0328 23.8684 13.2633L25.2662 15.6651L23.8357 17.0725L21.4608 15.6709C21.23 15.5346 20.9487 15.5148 20.7015 15.6174C20.454 15.72 20.2689 15.9328 20.2024 16.1922L19.4923 18.8787L17.4856 18.8627L16.7976 16.1922C16.7308 15.9328 16.546 15.72 16.2985 15.6174C16.1938 15.5741 16.083 15.5526 15.9722 15.5526C15.8219 15.5526 15.6719 15.5925 15.5389 15.6709L13.1371 17.0687L11.7297 15.6385L13.1316 13.2637C13.2676 13.0328 13.2878 12.7516 13.1851 12.5041C13.0825 12.2566 12.8698 12.0714 12.6103 12.005L9.92384 11.2948L9.94021 9.28812L12.6107 8.59979C12.8701 8.53297 13.0829 8.34819 13.1855 8.10067C13.2881 7.85316 13.2683 7.5719 13.132 7.34109L11.7342 4.93927L13.1643 3.53193L15.5392 4.93381C15.7697 5.06984 16.051 5.08996 16.2988 4.98734C16.5467 4.88472 16.7315 4.67198 16.7979 4.41254L17.5081 1.72604L19.5148 1.74207L20.2028 4.41254C20.2696 4.67198 20.4544 4.88472 20.7019 4.98734C20.9494 5.08996 21.2306 5.07052 21.4615 4.93381L23.8633 3.53602L25.2706 4.96654L23.8691 7.34143C23.733 7.5719 23.7129 7.85316 23.8155 8.10067C23.9178 8.34819 24.1309 8.53297 24.3903 8.59979L27.0598 9.28846Z",
    fill: "url(#paint5_linear_2_72)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6477 19.7313V38.2225C17.6477 38.6933 18.0292 39.0748 18.5 39.0748C18.9708 39.0748 19.3523 38.6933 19.3523 38.2225V19.7313C19.3523 19.2605 18.9708 18.879 18.5 18.879C18.0292 18.879 17.6477 19.2609 17.6477 19.7313Z",
    fill: "url(#paint6_linear_2_72)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62162 19.3195C3.46752 19.3195 3.32535 19.3219 3.19717 19.326C2.92681 19.3342 2.70964 19.551 2.70146 19.8214C2.65919 21.1943 2.77783 24.6049 4.79134 26.6184C6.32516 28.1519 8.6438 28.591 10.3191 28.6892C10.3293 28.6899 10.3392 28.6902 10.3491 28.6902C10.5496 28.6902 10.7327 28.5729 10.8155 28.3881C10.9024 28.1945 10.8608 27.9671 10.7105 27.8171L7.15123 24.2578C7.08679 24.1934 7.05133 24.1078 7.05133 24.0168C7.05133 23.9258 7.08679 23.8402 7.15157 23.7758C7.21566 23.7113 7.30123 23.6759 7.39226 23.6759C7.48329 23.6759 7.56886 23.7113 7.6333 23.7758L11.1922 27.3347C11.2901 27.4325 11.421 27.4844 11.5539 27.4844C11.6245 27.4844 11.6961 27.4697 11.7633 27.4394C11.9569 27.3524 12.0766 27.1547 12.0643 26.943C11.9661 25.2677 11.527 22.9487 9.99353 21.4152C8.16991 19.5919 5.21852 19.3195 3.62162 19.3195ZM7.99502 23.4144C7.82864 23.248 7.61045 23.1648 7.39226 23.1648C7.17407 23.1648 6.95588 23.248 6.7895 23.4144C6.45642 23.7471 6.45642 24.2868 6.7895 24.6196L10.3484 28.1785C8.77131 28.0861 6.57608 27.68 5.15238 26.2567C3.29842 24.4027 3.16887 21.2372 3.21217 19.837C3.33558 19.8333 3.47264 19.8309 3.62128 19.8309C5.1609 19.8309 7.94149 20.0866 9.63214 21.7773C11.0559 23.201 11.4616 25.3962 11.5539 26.9733L7.99502 23.4144Z",
    fill: "url(#paint7_linear_2_72)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2363 27.4397C25.3034 27.47 25.3747 27.4847 25.4456 27.4847C25.5786 27.4847 25.7095 27.4329 25.8073 27.335L29.3666 23.7757C29.4307 23.7113 29.5163 23.6758 29.6073 23.6758C29.6983 23.6758 29.7839 23.7113 29.8483 23.7757C29.9128 23.8402 29.9482 23.9257 29.9482 24.0168C29.9482 24.1078 29.9128 24.1934 29.8483 24.2578L26.2884 27.8178C26.1384 27.9678 26.0964 28.1952 26.1834 28.3888C26.2662 28.5732 26.4493 28.6909 26.6497 28.6909C26.6596 28.6909 26.6695 28.6905 26.6797 28.6898C28.3544 28.5923 30.673 28.1539 32.2089 26.618C34.2224 24.6045 34.341 21.1939 34.2988 19.821C34.2902 19.551 34.0734 19.3342 33.8034 19.3256C33.6735 19.3215 33.529 19.3192 33.3721 19.3192C31.7776 19.3192 28.8303 19.5916 27.0064 21.4155C25.4729 22.949 25.0338 25.268 24.9356 26.9433C24.923 27.1553 25.0426 27.3527 25.2363 27.4397ZM27.3677 21.7772C29.056 20.089 31.8318 19.8309 33.3721 19.8305C33.5232 19.8305 33.6626 19.8329 33.7877 19.837C33.831 21.2372 33.7015 24.4027 31.8475 26.2567C30.4231 27.681 28.2279 28.0878 26.6504 28.1795L30.2104 24.6195C30.5435 24.2868 30.5435 23.7471 30.2104 23.4144C30.044 23.248 29.8258 23.1648 29.6076 23.1648C29.3894 23.1648 29.1712 23.248 29.0049 23.4144L25.4459 26.9733C25.5383 25.3958 25.944 23.2009 27.3677 21.7772Z",
    fill: "url(#paint8_linear_2_72)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6478 57.4531V63.7155C17.6478 64.1864 18.0293 64.5679 18.5001 64.5679C18.9709 64.5679 19.3524 64.1864 19.3524 63.7155V57.4531C19.3524 56.9823 18.9709 56.6008 18.5001 56.6008C18.0293 56.6008 17.6478 56.9823 17.6478 57.4531Z",
    fill: "url(#paint9_linear_2_72)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6478 57.4531V63.7155C17.6478 64.1864 18.0293 64.5679 18.5001 64.5679C18.9709 64.5679 19.3524 64.1864 19.3524 63.7155V57.4531C19.3524 56.9823 18.9709 56.6008 18.5001 56.6008C18.0293 56.6008 17.6478 56.9823 17.6478 57.4531ZM18.841 57.4531V63.7155C18.841 63.9034 18.6879 64.0565 18.5001 64.0565C18.3122 64.0565 18.1592 63.9034 18.1592 63.7155V57.4531C18.1592 57.2652 18.3122 57.1122 18.5001 57.1122C18.6879 57.1122 18.841 57.2652 18.841 57.4531Z",
    fill: "url(#paint10_linear_2_72)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1216 33.019H3.26982C1.46666 33.019 0 34.4856 0 36.2888V41.2043C0 41.6751 0.381496 42.0566 0.852315 42.0566C1.32313 42.0566 1.70463 41.6751 1.70463 41.2043V36.2888C1.70463 35.4259 2.40694 34.7236 3.26982 34.7236H12.1216C12.6899 34.7236 13.2139 35.0321 13.4898 35.5285L15.2165 38.6368C15.445 39.0479 15.9635 39.1962 16.3757 38.9678C16.7872 38.739 16.9355 38.2201 16.7067 37.8086L14.9799 34.7008C14.4038 33.6633 13.3084 33.019 12.1216 33.019Z",
    fill: "url(#paint11_linear_2_72)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7592 62.8632H22.8093C22.3385 62.8632 21.957 63.2447 21.957 63.7156C21.957 64.1864 22.3385 64.5679 22.8093 64.5679H32.7592C35.0976 64.5679 37 62.6655 37 60.3271V41.611C37 39.2725 35.0976 37.3702 32.7592 37.3702H4.24078C1.90237 37.3702 0 39.2725 0 41.611V60.3271C0 62.6655 1.90237 64.5679 4.24078 64.5679H14.1907C14.6615 64.5679 15.043 64.1864 15.043 63.7156C15.043 63.2447 14.6615 62.8632 14.1907 62.8632H4.24078C2.8423 62.8632 1.70463 61.7256 1.70463 60.3271V41.611C1.70463 40.2125 2.8423 39.0748 4.24078 39.0748H32.7589C34.1574 39.0748 35.295 40.2125 35.295 41.611V60.3271C35.2954 61.7256 34.1577 62.8632 32.7592 62.8632Z",
    fill: "url(#paint12_linear_2_72)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9275 42.8076C11.7271 42.8076 10.7511 43.784 10.7511 44.9841V56.129C10.7511 57.329 11.7275 58.3054 12.9275 58.3054H24.0721C25.2725 58.3054 26.2485 57.329 26.2485 56.129V44.9841C26.2485 43.7837 25.2721 42.8076 24.0721 42.8076H12.9275ZM24.5442 44.9841V56.129C24.5442 56.3891 24.3325 56.6008 24.0724 56.6008H12.9279C12.6678 56.6008 12.456 56.3891 12.456 56.129V44.9841C12.456 44.724 12.6678 44.5122 12.9279 44.5122H24.0724C24.3325 44.5122 24.5442 44.724 24.5442 44.9841Z",
    fill: "url(#paint13_linear_2_72)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.327 46.4017C14.8562 46.4017 14.4747 46.7832 14.4747 47.254C14.4747 47.7249 14.8562 48.1064 15.327 48.1064H18.5C18.9708 48.1064 19.3523 47.7249 19.3523 47.254C19.3523 46.7832 18.9708 46.4017 18.5 46.4017H15.327Z",
    fill: "url(#paint14_linear_2_72)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.327 49.7043C14.8562 49.7043 14.4747 50.0858 14.4747 50.5566C14.4747 51.0274 14.8562 51.4089 15.327 51.4089H21.673C22.1438 51.4089 22.5253 51.0274 22.5253 50.5566C22.5253 50.0858 22.1438 49.7043 21.673 49.7043H15.327Z",
    fill: "url(#paint15_linear_2_72)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.327 53.0068C14.8562 53.0068 14.4747 53.3883 14.4747 53.8591C14.4747 54.3299 14.8562 54.7114 15.327 54.7114H21.673C22.1438 54.7114 22.5253 54.3299 22.5253 53.8591C22.5253 53.3883 22.1438 53.0068 21.673 53.0068H15.327Z",
    fill: "url(#paint16_linear_2_72)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6057 10.3027C14.6057 12.4499 16.353 14.1971 18.5001 14.1971C20.6473 14.1971 22.3945 12.4499 22.3945 10.3027C22.3945 8.15557 20.6473 6.40833 18.5001 6.40833C16.353 6.40833 14.6057 8.15557 14.6057 10.3027ZM20.6899 10.3027C20.6899 11.5103 19.7077 12.4925 18.5001 12.4925C17.2926 12.4925 16.3104 11.5103 16.3104 10.3027C16.3104 9.09516 17.2926 8.11295 18.5001 8.11295C19.7077 8.11295 20.6899 9.0955 20.6899 10.3027Z",
    fill: "url(#paint17_linear_2_72)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7991 10.3027C15.7991 11.7922 17.0108 13.0038 18.5003 13.0038C19.9898 13.0038 21.2014 11.7922 21.2014 10.3027C21.2014 8.81315 19.9898 7.6015 18.5003 7.6015C17.0108 7.6015 15.7991 8.81349 15.7991 10.3027ZM20.69 10.3027C20.69 11.5102 19.7078 12.4924 18.5003 12.4924C17.2927 12.4924 16.3105 11.5102 16.3105 10.3027C16.3105 9.0951 17.2927 8.11289 18.5003 8.11289C19.7078 8.11289 20.69 9.09544 20.69 10.3027Z",
    fill: "url(#paint18_linear_2_72)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6057 10.3027C14.6057 12.4499 16.353 14.1971 18.5001 14.1971C20.6473 14.1971 22.3945 12.4499 22.3945 10.3027C22.3945 8.15557 20.6473 6.40833 18.5001 6.40833C16.353 6.40833 14.6057 8.15557 14.6057 10.3027ZM21.8831 10.3027C21.8831 12.1679 20.3657 13.6857 18.5001 13.6857C16.6349 13.6857 15.1171 12.1683 15.1171 10.3027C15.1171 8.43717 16.6346 6.91971 18.5001 6.91971C20.3653 6.91971 21.8831 8.43752 21.8831 10.3027Z",
    fill: "url(#paint19_linear_2_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_72",
    x1: 6.8257,
    y1: 23.7361,
    x2: 12.2562,
    y2: 29.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_72",
    x1: 2.04622,
    y1: 19.2189,
    x2: 12.4652,
    y2: 30.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_72",
    x1: 24.39,
    y1: 23.7568,
    x2: 30.0158,
    y2: 29.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_72",
    x1: 24.2614,
    y1: 19.2187,
    x2: 34.6803,
    y2: 30.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_72",
    x1: 11.8803,
    y1: 28.3057,
    x2: 12.2001,
    y2: 31.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_72",
    x1: 9.17526,
    y1: 1.9348,
    x2: 27.3459,
    y2: 21.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_72",
    x1: 17.727,
    y1: 20.7577,
    x2: 21.0022,
    y2: 21.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_72",
    x1: 3.13103,
    y1: 20.1912,
    x2: 11.4122,
    y2: 29.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_72",
    x1: 25.3705,
    y1: 20.1909,
    x2: 33.6526,
    y2: 29.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_72",
    x1: 17.7271,
    y1: 57.3419,
    x2: 20.8592,
    y2: 58.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_72",
    x1: 17.7271,
    y1: 57.3419,
    x2: 20.8592,
    y2: 58.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_72",
    x1: 0.782057,
    y1: 33.8597,
    x2: 7.13525,
    y2: 46.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_72",
    x1: 1.72093,
    y1: 39.9002,
    x2: 24.0747,
    y2: 73.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_72",
    x1: 11.4719,
    y1: 44.2493,
    x2: 25.1676,
    y2: 59.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_72",
    x1: 14.7016,
    y1: 46.5603,
    x2: 15.5795,
    y2: 49.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_72",
    x1: 14.8491,
    y1: 49.8629,
    x2: 15.4143,
    y2: 52.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_72",
    x1: 14.8491,
    y1: 53.1653,
    x2: 15.4143,
    y2: 56.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_72",
    x1: 14.968,
    y1: 7.13286,
    x2: 21.8511,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_72",
    x1: 16.0504,
    y1: 8.10404,
    x2: 20.8245,
    y2: 13.3179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_72",
    x1: 14.968,
    y1: 7.13286,
    x2: 21.8511,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.ffbd78b01a0a308a20e9a857445b20a0.svg";
export { ForwardRef as ReactComponent };